const config = {
  // 用户版
  Audience: {
    edition: 'AUDiENCE',
  },
  // 展商版
  Business: {
    edition: 'BUSINESS'
  },
  post_url: 'http://zzfx.aieverybody.com/'
}

export default config